<template>
    <section class="hero is-fullheight is-dark is-bold">
        <div class="hero-body grid-container">
            <div class="flex-child">
                <transition name="fade-2s">
                    <h2 v-if="statusMensagemPadrao" class="subtitle is-1">Eu odeio comunicação não-violenta...</h2>
                </transition>
            </div>
            <div class="flex-child">
                <transition name="fade-2s">
                    <h1 v-if="statusMensagemFinal" class="title is-1" v-html="mensagemFinal"
                        style="font-size: 4rem;"></h1>
                </transition>
            </div>
            <div class="flex-child" style="min-height: 130px;">
                <transition-group name="fade-2s">
                        <router-link :key="1" v-if="statusBotaoRestart" to="/" class="button is-dark is-rounded"
                                     style="height: 130px; width: 130px;" title="Jogar novamente">
                            <i class="fas fa-undo fa-5x"></i><br>
                        </router-link>
                        <router-link :key="2" v-if="statusBotaoRestart && bonus" to="/bonus-stage" class="button is-dark is-rounded"
                                     style="height: 130px; width: 130px; margin-left: 50px"
                                     title="O que significa comunicação não-violenta?">
                            <i class="fas fa-question fa-5x"></i><br>
                        </router-link>
                </transition-group>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'EndingScreen',
        data() {
            return {
                statusMensagemPadrao: false,
                statusMensagemFinal: false,
                statusBotaoRestart: false,
                bonus: false
            }
        },
        computed: {
            mensagemFinal() {
                return this.$store.state.SaveState.mensagemFinal;
            }
        },
        mounted() {
            if (!this.mensagemFinal) {
                this.$router.push({
                    name: 'MainScreen'
                });
            }
            if (this.mensagemFinal === '... Mas em tempos sombrios como esses, talvez ela seja necessária.') {
                this.bonus = true;
            }
            setTimeout(() => {
                this.statusMensagemPadrao = true;
            }, 1000);
            setTimeout(() => {
                this.statusMensagemFinal = true;
            }, 3000);
            setTimeout(() => {
                this.statusBotaoRestart = true;
            }, 5000);
        }
    }
</script>

<style>
    .grid-container {
        display: grid !important;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr;
        grid-template-areas: "." "." ".";
        height: 100vh;
    }

    .flex-child {
        padding: 0 46px;
        text-align: center;
        color: #FFFFFF;
    }
</style>